var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "casino-group-container",
      class: [_vm.group.type.toLowerCase()]
    },
    [
      _c("div", { staticClass: "group-header" }, [
        !_vm.gridView
          ? _c("div", { staticClass: "group-top-ten-logo" }, [
              _c("img", {
                staticClass: "logo-holder-image",
                attrs: {
                  src: _vm.mediaServer(
                    "/static/casino/groups/" +
                      _vm.group.externalId +
                      "/assets/logo/" +
                      _vm.group.externalId +
                      ".svg"
                  ),
                  alt: "",
                  loading: "lazy"
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.gridView
          ? _c(
              "div",
              { staticClass: "see-all" },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "casino-page",
                        params: { slug: _vm.group.slug }
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("Casino.See.All")))]
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.group
        ? _c(
            "div",
            {
              staticClass: "slider-container",
              attrs: {
                "data-gid": _vm.group.groupId,
                id: "slider-container-" + _vm.group.groupId
              }
            },
            [
              !_vm.gridView
                ? _c("casino-slider", {
                    attrs: {
                      section: _vm.group.type.toLowerCase(),
                      group: _vm.setGroupSliderItemLimit(_vm.group),
                      gamesByGroup: _vm.filterGamesInfoDataByGroup(
                        _vm.group.gameIds
                      )
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.gridView
                ? _c("casino-grid-view", {
                    attrs: {
                      data: _vm.filterGamesInfoDataByGroup(this.group.gameIds),
                      groupData: this.group
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18a66987", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18a66987","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoTopGames.vue
// module id = null
// module chunks = 